/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import moment from 'moment';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';

import { Box, Button, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import DownloadIcon from '@mui/icons-material/Download';

import { useEnumApi } from 'contexts/EnumApiContext';
import { afileListFunc, BootstrapInput, importantYns, periodSearchSelectItems } from 'data/data';
import { getEquipmentCategoriesByQuery, getMasterEquipmentPartsByQuery } from 'components/axios/equipmentCategoryAxios';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import PageInfo from 'components/PageInfo';
import CommonLargeExcelDownload from 'components/CommonLargeExcelDownload';
import FileDownloadIcon from 'components/FileDownloadIcon';
import { getMaintenanceTasksByQuery, getMaintenanceTasksExcelByQueryString } from 'components/axios/maintenanceAxios';

const MaintenanceHistoryMonitoring = () => {
    const  { t } = useTranslation();
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [maintenanceTasks, setMaintenanceTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    
    const [taskStatus, setTaskStatus] = useState('');
    const [mntType, setMntType] = useState('');
    const [importantYn, setImportantYn] = useState('');
    const [trouble, setTrouble] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [equipmentCategoryLevel4Id, setEquipmentCategoryLevel4Id] = useState('');
    const [masterEquipmentPartId, setMasterEquipmentPartId] = useState('');
    const [periodSearch, setPeriodSearch] = useState('');
   
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
    const [equipmentCategoryLevel4s, setEquipmentCategoryLevel4s] = useState([]);
    const [masterEquipmentParts, setMasterEquipmentParts] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    const excelTitle = t('menu.cmms.maintenance-history');
    const excelTopHeaders = [
      "No.",
      t('message.common.subtitle.status'),
      t('message.common.subtitle.alertedAt'), 
      t('message.common.subtitle.alertType'), 
      t('message.common.subtitle.alertCategory'),
      t('message.common.subtitle.alertDetail'), 
      t('message.common.subtitle.alert.checkedAt'), 
      t('message.common.subtitle.alert.check.user'),
      t('message.common.subtitle.equipment.level1'), 
      t('message.common.subtitle.equipment.level2'), 
      t('message.common.subtitle.equipment.name'),
      t('message.common.subtitle.equipment.number'), 
      t('message.common.subtitle.position'),
      t('message.common.subtitle.madeYmd'), 
      t('message.common.subtitle.main.management'), 
      t('message.common.subtitle.breakdown.maintenance.cause'),
      t('message.common.subtitle.work.start.date'), 
      t('message.common.subtitle.work.start.time'), 
      t('message.common.subtitle.work.end.date'), 
      t('message.common.subtitle.work.end.time'), 
      t('message.common.subtitle.actionType'), 
      t('message.common.subtitle.worker'), 
      t('message.common.subtitle.work.detail'), 
      t('message.common.subtitle.status.report.file'), 
      t('message.common.subtitle.equipment.component')+"-"+t('message.common.subtitle.location')+" "+t('message.common.subtitle.input.material')+" "+t('message.common.subtitle.part.name'), 
    ];
    const colWidths = [
      0,0,0,0,0,
      0,0,0,0,0,
      0,0,0,0,0,
      0,0,0,0,0,
      0,0,0,0,50];
    const [excelParam, setExcelParam] = useState([]);

    const toDate = new Date();

    const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
  
    let qs = queryString.parse(window.location.search);

    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');

    const onRefresh = useCallback(() => {
      setIsLoading(false)
    }, []);
    

    // case "O1_R":  // 대기
    //   return "condition1";
    // case "O2_P":  // 진행중
    //   return "condition2";
    // case "O3_C":  // 완료
    //   return "condition5";
    // default:
    //   return "";
      
    let columns = [
      { field: 'no', headerName: 'No.', sortable: false, width: 80
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
      },
      { field: 'status', headerName: t('message.common.subtitle.status'), sortable: true, width: 80,
        cellClassName : 'statusButton'
        , renderCell:(params)=>
          (<div style={{textAlign:"center"}} className={params.row?.status === 'O1_R' ? 'condition1' : 
                      (params.row?.status === 'O2_P' ? 'condition2' : (params.row?.status === 'O3_C' ? 'condition5' : 'condition6'))}>
              <Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("MaintenanceStatus", params.row?.status)?.[0]?.title}</Link>
          </div>)
      },
      { field: 'workingBgnAt', headerName: t('message.common.subtitle.maintenance.workingBgnAt'), width: 150
        // , valueGetter:(params)=>dayjs(params.row?.workingBgnAt).format("YYYY-MM-DD HH:mm")
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.workingBgnAt && dayjs(params.row?.workingBgnAt).format("YYYY-MM-DD HH:mm")}</Link>)
      },
      { field: 'equipment.name', headerName: t('message.common.subtitle.equipment.name'), minWidth: 200
        // , valueGetter:(params)=>params.row?.equipment?.name 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.equipment?.name}</Link>)
      },
      { field: 'equipment.equipmentNo', headerName: t('message.common.subtitle.equipment.number'), width: 150
        // , valueGetter:(params)=>params.row?.equipment?.equipmentNo 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.equipment?.equipmentNo}</Link>)
      },
      { field: 'equipmentCtgr.name', headerName: t('message.common.subtitle.material.classification'), width: 150
        // , valueGetter:(params)=>params.row?.equipmentCtgr?.name 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.name}</Link>)
      },
      { field: 'position', headerName: t('message.common.subtitle.position'), width: 100
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.componentLocation?.name}</Link>)
      },
      { field: 'equipmentParts', headerName: t('message.common.subtitle.material'), sortable: false, width: 150
        // , valueGetter:(params)=>params.row?.equipmentParts?.[0]?.masterEquipmentPart?.name
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.equipmentParts?.[0]?.masterEquipmentPart?.name}</Link>)
      },
      { field: 'type', headerName: t('message.common.subtitle.actionType'), width: 100
        // , valueGetter:(params)=>getEnumValueByEnumNameAndCode("MaintenanceType", params.row?.type)?.[0]?.title 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("MaintenanceType", params.row?.type)?.[0]?.title}</Link>)
      },
      { field: 'trouble', headerName: t('message.common.subtitle.breakdown.maintenance.cause'), width: 100
        // , valueGetter:(params)=>getEnumValueByEnumNameAndCode("MaintenanceType", params.row?.type)?.[0]?.title 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentTrouble", params.row?.trouble)?.[0]?.title}</Link>)
      },
      { field: 'worker', headerName: t('message.common.subtitle.worker'), width: 100 
        , renderCell:(params)=>(<Link to={'/maintenance-history/'+params.row?.id+searchParamString}>{params.row?.worker}</Link>)
      },
      { field: 'reportFiles', headerName: t('message.common.subtitle.status.report.file'), sortable: false, width: 80,
        // renderCell : (params) => (<>params.row?.equipment?.name</>)
        // ,
        cellClassName : 'statusReport',
        disableClickEventBubbling: true,
        renderCell : (params) => (params.row?.statusReport?.reportFiles?.length > 0 && 
          <div id={`fileDiv${(params.row?.idx)}`} className="file_Div" style={{textAlign:"center", width:"90%"}}>
            <Link id={`fileATag${(params.row?.idx)}`} className="file_ATag" to={'#'/*'/management/maintenance/history/'+params.row?.id+searchParam*/}>
              <DownloadIcon />
            </Link>
            <div id={`fileList${(params.row?.idx)}`} className="fileListDiv">
              <ul>
                {params.row?.statusReport?.reportFiles.map(function(afileList01, count02) {
                  return (
                <li key={count02}>
                  <FileDownloadIcon file={afileList01} viewFileName={true} fontColor={"#000"}/>
                </li>
                  )
                })}
              </ul>
            </div>
          </div>
        )
      },
    ];

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);
      
      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "status,asc"});
        searchOrders.push({sort : "alertedAt,desc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page)};
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchStatus) setTaskStatus(qs.searchStatus);
        if (qs.searchImportantYn) setImportantYn(qs.searchImportantYn);
        if (qs.searchMntType) setMntType(qs.searchMntType);
        if (qs.searchTrouble) setTrouble(qs.searchTrouble);
        if (qs.searchSubway) setSubwayCode(qs.searchSubway);
        if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
        if (qs.searchStation) setStationId(qs.searchStation);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);
        if (qs.searchlevel4) setEquipmentCategoryLevel4Id(qs.searchlevel4);
        if (qs.searchPartId) setMasterEquipmentPartId(qs.searchPartId);
        if (qs.periodSearch >= 0) setPeriodSearch(qs.periodSearch);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchImportantYn) {searchParamCopy.searchImportantYn = qs.searchImportantYn};
        if (qs.searchMntType) {searchParamCopy.searchMntType = qs.searchMntType};
        if (qs.searchTrouble) {searchParamCopy.searchTrouble = qs.searchTrouble};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchWorkingPart) {searchParamCopy.searchWorkingPart = qs.searchWorkingPart};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.searchlevel4) {searchParamCopy.searchlevel4 = qs.searchlevel4};
        if (qs.searchPartId) {searchParamCopy.searchPartId = qs.searchPartId};
        if (qs.searchIotInstlYn) {searchParamCopy.searchIotInstlYn = qs.searchIotInstlYn};
        if (qs.periodSearch >= 0) {searchParamCopy.periodSearch = qs.periodSearch};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>{orders.push({sort:order})});
            (qs.sort)?.map(order=>sortModel.push({"field": order.split(',')[0],"sort": order.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchImportantYn, qs.searchMntType, qs.searchTrouble, qs.searchStatus, qs.searchSubway
      , qs.searchWorkingPart, qs.searchStation, qs.searchlevel1, qs.searchlevel2, qs.searchlevel3, qs.searchlevel4, qs.searchPartId, qs.periodSearch]);
    
    // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
          setEquipmentCategoryLevel4s([]);
          setMasterEquipmentParts([]);
        });
      } else {
        setEquipmentCategoryLevel3s([]);
        setEquipmentCategoryLevel4s([]);
        setMasterEquipmentParts([]);
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
          setEquipmentCategoryLevel4s([]);
          setMasterEquipmentParts([]);
        });
      } else {
        setEquipmentCategoryLevel4s([]);
        setMasterEquipmentParts([]);
      }
    },[equipmentCategoryLevel2Id]);

    // 구성부 목록
    useEffect(()=>{
      if (equipmentCategoryLevel3Id) {
        const param = { "parent.id": equipmentCategoryLevel3Id, depth: 4, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel4s(list);
            } else {
              setEquipmentCategoryLevel4s([]);
            }
          } else {
            setEquipmentCategoryLevel4s([]);
          }
          setMasterEquipmentParts([]);
        });
      } else {
        setMasterEquipmentParts([]);
      }
    },[equipmentCategoryLevel3Id]);

    // 자재 목록
    useEffect(()=>{
      if (equipmentCategoryLevel4Id) {
        const param = { "equipmentCtgr.id": equipmentCategoryLevel4Id, size:100, sort : "name,asc" };
        // console.log(param)
        getMasterEquipmentPartsByQuery(param).then((data) => {
          // console.log(data)
          if (data && data._embedded) {
            const list = data._embedded.masterEquipmentParts;
            if (list) {
              setMasterEquipmentParts(list);
            } else {
              setMasterEquipmentParts([]);
            }
          } else {
            setMasterEquipmentParts([]);
          }
        });
      }
    },[equipmentCategoryLevel4Id]);
  
    // 목록
    useEffect(()=> {
      if ((!isLoading || sortModel != null) && !isNaN(currentPage) && getEnumValueByEnumName("EquipmentTrouble") && isParam) {
        maintenanceTasksList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize, isParam, trouble, getEnumValueByEnumName("EquipmentTrouble"), sortModel]);
    
    const maintenanceTasksList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  
      let param = {
          page : curPage,
          size : pageSize,
      };
      if (taskStatus) {
          param.status = taskStatus;
      }
      // param.status = ['O2_P','O3_C'];
      if (importantYn) {
        param.importantYn = (importantYn === 'Y' ? true:false);
      }
      if (mntType) {
        param.type = mntType;
      }
      if (trouble) {
        param.trouble = trouble;
      }
      if (equipmentCategoryLevel1Id) {
        param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }
      if (equipmentCategoryLevel2Id) {
        param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }
      if (equipmentCategoryLevel3Id) {
        param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }
      if (equipmentCategoryLevel4Id) {
        param['equipmentCtgr.id'] = equipmentCategoryLevel4Id;
      }
      if (masterEquipmentPartId) {
        param['equipmentParts.masterEquipmentPart.id'] = masterEquipmentPartId;
      }
      if (searchKeyword) {
          if (searchField === 'name') {
              param['equipment.name'] = 'contains('+searchKeyword+')';
          } else if (searchField === 'equipmentNo') {
              param['equipment.equipmentNo'] = 'contains('+searchKeyword+')';
          }
      }
      
      if (sortModel && sortModel.length > 0) {
        param.sort = [sortModel[0].field+","+sortModel[0].sort];
      } else {
        param.sort = ['status,asc','equipmentAlert.alertedAt,desc'];
      }

      if (periodSearch !== '' && periodSearch >= 0) {
        if (periodSearch % 5 === 0)
          param.workingBgnAt = 
          ["gte("+(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), 0, 1)).format())+")",
            "and(lte("+(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), 12, 0, 23 , 59, 59)).format())+"))"
          ];
        else {
          param.workingBgnAt = [
            "gte("+(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), (((periodSearch%5)-1)*3), 1)).format())+")",
            "and(lte("+(moment(new Date(toDate.getFullYear()-parseInt(periodSearch/5), ((periodSearch%5)*3), 0, 23 , 59, 59)).format())+"))"
          ];
        }
      }

      // if (taskStatus ==='report') {
      //   param["statusReport.reportFiles.id"] = "isNotNull()";
      // }

      const { page, size, ...rest } = param;
      setExcelParam(rest);

      Promise.all([
        getMaintenanceTasksByQuery(param).then((data)=>{
            if (data != null) {
              //console.log(data);
              if(data.page) {
                  setPageInfo(data.page);
              } else {
                  setCurrentPage(0);
                  pageInfo = {
                  size : pageInfo.size,
                  totalElements : 0,
                  totalPages : 0,
                  number : 0
                  }
                  setPageInfo(pageInfo);
              }
              if(data._embedded) {
                  let list = data._embedded.maintenanceTasks;
                  list && list.map(function(equipmentAlert, i) {
                      equipmentAlert.idx = (i+1);
                      equipmentAlert.no = data.page.totalElements-((currentPage)*data.page.size)-i;
                  })
                  setMaintenanceTasks(list);
                  setIsLoading(true);
                  return data.page.totalElements;
              } else {
                  setMaintenanceTasks([]);
              }
            } else {
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
              setMaintenanceTasks([]);
            }
            setIsLoading(true);
            return 0;
        })
      ])
      setIsLoading(true);
    }

    const dataMappingRules = (column, index, totalElements, startIndex) => {
      const rowNumber = totalElements - (startIndex + index);
      const alertDtl = column?.equipmentAlert?.alertDtl;

      let rowData = [
        rowNumber,
        ((getEnumValueByEnumNameAndCode("MaintenanceStatus", column.status)?.[0]?.title) || ''),
        ((column.equipmentAlert?.alertedAt && dayjs(column.equipmentAlert?.alertedAt).format('YYYY-MM-DD HH:mm')) || ''),
        ((getEnumValueByEnumNameAndCode("AlertType", column.equipmentAlert?.alertType)?.[0]?.title) || ''),
        ((getEnumValueByEnumNameAndCode("AlertCategory", column.equipmentAlert?.alertCategory)?.[0]?.title) || ''),
        ((alertDtl) || ''),
        ((column?.equipmentAlert?.fieldChkedAt && dayjs(column?.fieldChkedAt?.alertedAt).format("YYYY-MM-DD HH:mm")) || ''),
        ((column?.equipmentAlert?.fieldChkUser) || ''),
        ((column?.equipment?.equipmentCtgr?.parent?.parent?.name) || ''),
        ((column?.equipment?.equipmentCtgr?.parent?.name) || ''),
        ((column?.equipment?.name) || ''),
        ((column?.equipment?.equipmentNo) || ''),
        ((column?.equipment?.location) || ''),
        ((column?.equipment?.madeYmd) || ''),
        ((column?.importantYn != null ? (column.importantYn ? 'O' : 'X') : '-')),
        ((getEnumValueByEnumNameAndCode("EquipmentTrouble", column?.trouble)?.[0]?.title) || ''),
        ((column?.workingBgnAt && dayjs(column?.workingBgnAt).format("YYYY-MM-DD")) || ''),
        ((column?.workingBgnAt && dayjs(column?.workingBgnAt).format("HH:mm:ss")) || ''),
        ((column?.workingEndAt && dayjs(column?.workingEndAt).format("YYYY-MM-DD")) || ''),
        ((column?.workingEndAt && dayjs(column?.workingEndAt).format("HH:mm:ss")) || ''),
        ((getEnumValueByEnumNameAndCode("MaintenanceType", column?.type)?.[0]?.title) || ''),
        ((column?.worker) || ''),
        ((column?.remark) || ''),
        ((column?.statusReport?.reportFiles) ? 'O' : 'X'),
      ];

      if (column?.equipmentParts?.length > 0) {
        let columnDesc = '';
        column.equipmentParts.map((part, i) => {
          columnDesc += (part.masterEquipmentPart?.equipmentCtgr?.name) + '-';
          columnDesc += (part.componentLocation?.name) + ' ';
          columnDesc += (part.masterEquipmentPart?.name ?? '') + ' ';
          columnDesc += (part.subPart ?? '') ;
          if (i < column.equipmentParts.length-1)
            columnDesc += "\n";
        });
        rowData.push(columnDesc);
      }

      return rowData;
    };

    useEffect(()=>{
      setTimeout(() => {
        if (isLoading) {
          // console.log(1111)
          afileListFunc();
        }
        // console.log('3초가 지났습니다');
      }, 1500);   
    }, [isLoading, sortModel]);
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
  
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      maintenanceTasksList(0);
      // setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      // console.log(searchParamCopy);
      // console.log(periodSearch)
      searchParamCopy.page = 0;
      
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (importantYn) {searchParamCopy.searchImportantYn = importantYn};
      if (mntType) {searchParamCopy.searchMntType = mntType};
      if (trouble) {searchParamCopy.searchTrouble = trouble};
      if (taskStatus) {searchParamCopy.searchStatus = taskStatus};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      if (equipmentCategoryLevel4Id) {searchParamCopy.searchlevel4 = equipmentCategoryLevel4Id};
      if (masterEquipmentPartId) {searchParamCopy.searchPartId = masterEquipmentPartId};
      if (periodSearch >= 0) {searchParamCopy.periodSearch = periodSearch};
      
      setSearchParam(searchParamCopy)

      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event)
      handleClose();
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };

    return (
      <div className="sub_container">
        <div className='search_section'>
          <div className="selectbox">
            <div className="desktop_serach">
                <Box component="form">
                <div>
                  {getEnumValueByEnumName("MaintenanceStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={taskStatus}
                      label={t('message.common.subtitle.status')}
                      labelName={t('message.common.subtitle.status')}
                      name={'taskStatus'}
                      defaultValue={taskStatus}
                      onChange={(e)=>{
                        setTaskStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("MaintenanceStatus")}
                  />
                  </FormControl>
                  }
                  {importantYns && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={importantYn}
                      label={t('message.common.select.importantYn')}
                      labelName={t('message.common.select.importantYn')}
                      name={'importantYn'}
                      defaultValue={importantYn}
                      onChange={(e)=>{
                        setImportantYn(e.target.value);
                      }}
                      list={importantYns}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("MaintenanceType") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={mntType}
                      label={t('message.common.subtitle.actionType')}
                      labelName={t('message.common.subtitle.actionType')}
                      name={'mntType'}
                      defaultValue={mntType}
                      onChange={(e)=>{
                        setMntType(e.target.value);
                      }}
                      list={getEnumValueByEnumName("MaintenanceType")}
                  />
                  </FormControl>
                  }
                  {getEnumValueByEnumName("EquipmentTrouble") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={trouble}
                      label={t('message.common.subtitle.breakdown.maintenance.cause')}
                      labelName={t('message.common.subtitle.breakdown.maintenance.cause')}
                      name={'trouble'}
                      defaultValue={trouble}
                      onChange={(e)=>{
                        setTrouble(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentTrouble")}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel4s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel4Id}
                      label={t('message.common.select.component.part')}
                      labelName={t('message.common.select.component.part')}
                      name={'level4'}
                      defaultValue={equipmentCategoryLevel4Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel4Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel4s}
                  />
                  </FormControl>
                  }
                  {masterEquipmentParts && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={masterEquipmentPartId}
                      label={t('message.common.subtitle.material')}
                      labelName={t('message.common.subtitle.material')}
                      name={'parts'}
                      defaultValue={masterEquipmentPartId}
                      onChange={(e)=>{
                        setMasterEquipmentPartId(e.target.value);
                      }}
                      list={masterEquipmentParts}
                  />
                  </FormControl>
                  }
                  
                  {periodSearchSelectItems && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={periodSearch}
                      label={t('message.common.select.maintenance.period')}
                      labelName={t('message.common.select.maintenance.period')}
                      name={'periodSearch'}
                      defaultValue={periodSearch}
                      onChange={(e)=>{
                        setPeriodSearch(e.target.value);
                      }}
                      list={periodSearchSelectItems}
                  />
                  </FormControl>
                  }
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                    <FormControl sx={{ m: 1, minWidth: 80 }}>
                      <CustomEnumSelect
                        key={searchField}
                        label={t('message.common.btn.search')}
                        labelName={t('message.common.btn.search')}
                        name={'searchField'}
                        defaultValue={searchField}
                        onChange={(e)=>{
                          setSearchField(e.target.value);
                        }}
                        list={searchFields}
                    />
                    </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>

                    <Button variant="contained" style={{marginTop:"0",padding:"10px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                  </div>
                </div>
                </Box>
            </div>
          </div>
        </div>

          <Box
            id="tableDiv"
            sx={{
              mt: 3,
              padding: "20px",
              borderRadius: "20px",
              overflow: "hidden",
              background: "#182131",
              border: "1px solid rgba(255,255,255,0.06)",
              boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
            }}
          >
            <DataGridPro
              rows={maintenanceTasks && maintenanceTasks !== undefined ? maintenanceTasks : []}
              columns={columns}
              disableColumnFilter
              sortModel={sortModel || []}
              onSortModelChange={setSortModel}
              sx={{
                border: 0,
                color: "#fff",
                backgroundColor: "#182131",

                "& .MuiDataGrid-main": {
                  backgroundColor: "#182131",
                },

                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#1d2738",
                  borderBottom: "1px solid rgba(255,255,255,0.08)",
                  minHeight: "56px !important",
                },

                "& .MuiDataGrid-columnHeader": {
                  outline: "none !important",
                },

                "& .MuiDataGrid-columnHeaderTitle": {
                  fontWeight: 700,
                  fontSize: 14,
                  color: "#cbd5e1",
                },

                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid rgba(255,255,255,0.06)",
                  color: "#fff",
                  outline: "none !important",
                  display: "flex",
                  alignItems: "center",
                  fontSize: 14,
                },

                "& .MuiDataGrid-row": {
                  backgroundColor: "#182131",
                  transition: "all .15s ease",
                },

                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#243047",
                },

                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid rgba(255,255,255,0.08)",
                  backgroundColor: "#1d2738",
                  color: "#fff",
                },

                "& .MuiTablePagination-root": {
                  color: "#fff",
                },

                "& .MuiIconButton-root": {
                  color: "#94a3b8",
                },

                "& .MuiDataGrid-sortIcon": {
                  color: "#94a3b8",
                },

                "& .MuiDataGrid-menuIconButton": {
                  color: "#94a3b8",
                },

                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },

                "& .MuiDataGrid-columnHeader:focus": {
                  outline: "none",
                },

                "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                  display: "none",
                },

                "& .MuiDataGrid-cell.statusReport": {
                  overflow: "unset !important",
                },
              }}
            />
          

            <div className="btn_right">
              <div className='no-print-page'>
                  <CommonLargeExcelDownload 
                    title={excelTitle}
                    excelHeader={excelTopHeaders}
                    colWidths={colWidths}
                    excelParam={excelParam}
                    fetchApiFn={getMaintenanceTasksExcelByQueryString} // 👈 액시오스 함수 매핑
                    mappingFn={dataMappingRules}               // 👈 파싱 룰 데이터 매핑
                    apiKey="maintenanceTasks"                          // 👈 JSON 응답 타겟 키 지정
                    pageSize={5000}                                   // 백엔드 제한 수치 수용
                    totalCount={pageInfo.totalElements}
                  />
              </div>
            </div>
            
            <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
          </Box>
      </div>
    );
}

export default MaintenanceHistoryMonitoring;